// Integration crypto core: SHA-256 / HMAC-SHA256 hex via WebCrypto, stable JSON for request hashes.
const enc = new TextEncoder();
const toHex = (buf: ArrayBuffer) =>
  [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
const toBytes = (v: string | Uint8Array) =>
  typeof v === "string" ? enc.encode(v) : v;

export async function sha256Hex(input: string | Uint8Array): Promise<string> {
  return toHex(await crypto.subtle.digest("SHA-256", toBytes(input)));
}

export async function hmacSha256Hex(
  secret: string,
  body: string | Uint8Array,
): Promise<string> {
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secret),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  return toHex(await crypto.subtle.sign("HMAC", key, toBytes(body)));
}

/** Stable JSON (keys sorted recursively, undefined dropped): request hashes for idempotency. */
export function canonicalJson(v: unknown): string {
  if (v === null || v === undefined || typeof v !== "object")
    return JSON.stringify(v ?? null);
  if (Array.isArray(v)) return `[${v.map(canonicalJson).join(",")}]`;
  const o = v as Record<string, unknown>;
  return `{${Object.keys(o)
    .filter((k) => o[k] !== undefined)
    .sort()
    .map((k) => `${JSON.stringify(k)}:${canonicalJson(o[k])}`)
    .join(",")}}`;
}

export { timingSafeEqualStr } from "../email/http.ts";
